import $ from "jquery";
import Rellax from "rellax";

$(() => {
  const imageryContent = $(".home .imagery .content");

  if (!!imageryContent.length) {
    imageryContent.each(function() {
      new Rellax(this, {
        speed: 0.5,
        center: true
      });
    });
  }
});
